// extracted by mini-css-extract-plugin
export default {"copyLinkButton":"CopyButton_copyLinkButton__S-yCl","tooltipCopy":"CopyButton_tooltipCopy__LeTQX"};